import { Box } from "@chakra-ui/react";

import { Text } from "src/components/text";
import { theme } from "src/components/theme";

export const Footer: React.FC = () => (
  <Box
    as="footer"
    position="fixed"
    bottom={0}
    left={0}
    right={0}
    textAlign="center"
    py={2}
    bg="white"
    zIndex={10}
  >
    <Text
      as="small"
      style={{
        color: theme.colors.lightGrey,
        fontSize: "12px"
      }}
    >
      V1.1.7 © Braided Communications Ltd. All rights reserved.
    </Text>
  </Box>
);
